// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"app-components-staticpages-blocks-articlequoteblock--container"};